import React from "react";
import RadioButtonContainer from "../../ui/layout/page/forms-container/form-item-container/radio-button-container/input-container";
import OnboardingRadioButton from "../shared/components/formik/radiobutton";
import FormContainer from "../../ui/layout/page/forms-container/form-base-container";
import { useMessageSource } from "react-message-source";
import { CompanyClassification } from "../../api/commercial/generated-types";

export const CompanyClassificationComponent: React.FC = () => {
  const { getMessage } = useMessageSource();

  return (
    <FormContainer>
      <RadioButtonContainer>
        <OnboardingRadioButton
          title={getMessage(
            "RegulatoryInformation.company-classification.title",
          )}
          id={"companyClassification"}
          name={"companyClassification"}
          fullWidth
          wrap
          values={[
            {
              id: CompanyClassification.LISTED_COMPANY_OR_SUBSIDIARY_MAJORITY,
              value:
                CompanyClassification.LISTED_COMPANY_OR_SUBSIDIARY_MAJORITY,
              label: getMessage(
                "RegulatoryInformation.company-classification.LISTED_COMPANY_OR_SUBSIDIARY_MAJORITY",
              ),
            },
            {
              id: CompanyClassification.AUTHORITY_OR_NON_PROFIT,
              value: CompanyClassification.AUTHORITY_OR_NON_PROFIT,
              label: getMessage(
                "RegulatoryInformation.company-classification.AUTHORITY_OR_NON_PROFIT",
              ),
            },
            {
              id: CompanyClassification.UNREGISTERED_PARTNERSHIP,
              value: CompanyClassification.UNREGISTERED_PARTNERSHIP,
              label: getMessage(
                "RegulatoryInformation.company-classification.UNREGISTERED_PARTNERSHIP",
              ),
            },
            {
              id: CompanyClassification.BANK_OR_ANOTHER_FINANCIAL_INTERMEDIARY,
              value:
                CompanyClassification.BANK_OR_ANOTHER_FINANCIAL_INTERMEDIARY,
              label: getMessage(
                "RegulatoryInformation.company-classification.BANK_OR_ANOTHER_FINANCIAL_INTERMEDIARY",
              ),
            },
            {
              id: CompanyClassification.NON_OPERATING_FOUNDATION,
              value: CompanyClassification.NON_OPERATING_FOUNDATION,
              label: getMessage(
                "RegulatoryInformation.company-classification.NON_OPERATING_FOUNDATION",
              ),
            },
            {
              id: CompanyClassification.NON_OPERATIONAL_COMPANY,
              value: CompanyClassification.NON_OPERATIONAL_COMPANY,
              label: getMessage(
                "RegulatoryInformation.company-classification.NON_OPERATIONAL_COMPANY",
              ),
            },
            {
              id: CompanyClassification.NONE_OF_THE_AVAILABLE_CLASSIFICATIONS,
              value:
                CompanyClassification.NONE_OF_THE_AVAILABLE_CLASSIFICATIONS,
              label: getMessage(
                "RegulatoryInformation.company-classification.NONE_OF_THE_AVAILABLE_CLASSIFICATIONS",
              ),
            },
          ]}
        />
      </RadioButtonContainer>
    </FormContainer>
  );
};
